import React from 'react';
import NorthArrow from '../../../components/NorthArrow';
import FigurePreview from '../shared/FigurePreview';
import StepActions from '../shared/StepActions';
import StepShell from '../shared/StepShell';
import { pageImage } from '../shared/wizardUtils';

export default function ArrowStep({ grave, arrow, onNext, onCancel }) {
  const image = pageImage(grave);

  if (!arrow || !image) {
    return (
      <StepShell>
        <p>{arrow ? 'No page image found.' : 'No arrow found for this grave.'}</p>
        <StepActions onNext={() => onNext({})} onCancel={onCancel} />
      </StepShell>
    );
  }

  return (
    <StepShell>
      <div className="data-step-layout">
        <FigurePreview figures={grave.figures} image={image} showContours={false} />
        <div>
          <h3>Arrow Orientation</h3>
          <NorthArrow
            arrow={arrow}
            next_url="#"
            image={image}
            onFinish={(angle) => onNext({ arrowId: arrow.id, angle })}
          />
          <StepActions onCancel={onCancel} />
        </div>
      </div>
    </StepShell>
  );
}
